<template>
  <div class="appbar">
    <div class="card-group">
      <div class="card login">
        <div class="login--body">
          <h1>Вход</h1>
          <span class="login__title">Войти в существующий аккаунт</span>
          <span class="login__text">Для работы с данным сайтом добавьте его в исключения блокировщика рекламы или временно отключите его</span>
          <el-form ref="form" :model="model" :rules="rules">
            <el-form-item prop="username">
              <el-input v-model="model.username" placeholder="Логин">
                <i slot="prepend" class="el-icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="model.password"
                        placeholder="Пароль" show-password>
                <i slot="prepend" class="el-icon-lock"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary"
                         @click="onSubmit">Войти
              </el-button>
              <span class="login__found" @click="toRecoveryPage">Забыли пароль?</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--
      <div class="card register">
        <div class="login--body">
          <h1>Регистрация</h1>
          <span class="login__text">Нажимая кнопку «Войти» или «Регистрация» или осуществляя вход или регистрацию через социальную сеть, я соглашаюсь <a
              href="https://www.formacar.com/ru/personal-data.html" style="color: white; font-weight: 900"
              target="_blank">на обработку персональных данных.</a></span>
          <el-form ref="form" :model="model" :rules="rules">
            <el-form-item>
              <el-button style="margin-top: 2rem" type="info">Зарегистрироваться!</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      -->
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
  data() {
    return {
      loading: false,
      model: {
        username: '',
        password: '',
      },
      rules: {
        username: [
          {required: true, message: 'Имя обязательно', trigger: 'change'},
        ],
        password: [
          {required: true, message: 'Пароль обязателен', trigger: 'change'},
        ],
      },
    };
  },
  computed: {
    ...mapState({}),
    ...mapGetters('auth', ['isAdmin']),
  },
  methods: {
    ...mapActions('auth', ['login']),
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.login(this.model)
              .then(() => {
                this.loading = false;
                if (this.isAdmin) {
                  this.$router.replace('/');
                } else {
                  this.$router.replace('/');
                }
              })
              .catch((error) => {
                console.log(error);
                this.loading = false;
                let msg = 'Server error';
                console.log('error', error)
                if (error.data.status === 401) {
                  msg = error.data.data.error_description === 'PaymentRequired'
                      ? 'Your payment has been expired' : 'Invalid username or password';
                }

                this.$notify({
                  title: 'Authentication',
                  message: msg,
                });
              });
          return true;
        }
        return false;
      });
    },
    toRecoveryPage() {
      this.$router.replace({path: '/recovery/code'});
    }
  },
};
</script>

<style lang="scss" scoped>
.card-group {
  flex-flow: row wrap;
  display: flex;
}

.card {
  flex: 1 0;
  margin-bottom: 0;
  padding: 1.5rem
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.appbar {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login {
  line-height: 1.5;
  max-width: 420px;
  max-height: 450px;
  text-align: left;

  &--body {
    padding: 1.25rem;
  }

  &__title {
    display: block;
    color: #73818f;
    margin-bottom: .5rem;
  }

  &__text {
    display: block;
    color: #63c2de;
    padding-bottom: .5rem;
  }

  &__found {
    font-weight: 400;
    color: #20a8d8;
    cursor: pointer;
    position: absolute;
    right: 0;
  }
}

.register {
  padding-top: 4rem;
  line-height: 1.5;
  width: 340px;
  background-color: #20a8d8;
  color: white;

  p {
    margin-top: 0;
    margin-bottom: 1rem;
  }

  .login__text {
    color: white;
  }
}
</style>
